import { getPaymentProducts } from './pcsPaymentLogic';
import { Grid, Typography } from "@mui/material";
import React from "react";
import { CurrencyCodeIconEnum } from "../../app/enums/currencyCodeIconEnum";
import { PaymentDto } from "../../app/models/payment/paymentDto";
import { useAppSelector } from "../../app/store/configureStore";
import { convertToPrecesion } from "../../app/utils/util";

interface Props {
    paymentDetails: PaymentDto | null;
}

export default function PcsSubscriptionFeesDue(props: Props) {
    const { paymentDetails } = props;
    const { products } = useAppSelector(state => state.ReferenceData);

    return <>
        <Grid size={{ xs: 12 }} sx={{ paddingTop: '1% !important' }}>
            <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Fees Due</Typography>
        </Grid>

        <Grid container rowSpacing={4}>

            <Grid size={{ sm: 12 }}></Grid>

            {
                getPaymentProducts(paymentDetails, products).map((item) => (
                    <React.Fragment key={item.year}>
                        <Grid size={{ xs: 5, md: 6, sm: 5 }}>
                            {item.year}
                        </Grid>

                        <Grid size={{ xs: 0, md: 1, sm: 1 }}></Grid>

                        <Grid size={{ xs: 7, md: 5, sm: 6 }}>
                            {CurrencyCodeIconEnum.EUR} {convertToPrecesion(item.amount?.toString())}
                        </Grid>
                    </React.Fragment>
                ))
            }

            <>
                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 5, md: 6, sm: 5 }}>
                    <b>Total Due</b>
                </Grid>

                <Grid size={{ xs: 0, md: 1, sm: 1 }}></Grid>

                <Grid size={{ xs: 7, md: 5, sm: 6 }}>
                    {CurrencyCodeIconEnum.EUR} {paymentDetails?.amount}
                </Grid>
            </>

        </Grid>
    </>
}
